<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <!--        <el-button-->
        <!--          type="danger"-->
        <!--          size="small"-->
        <!--          icon="el-icon-delete"-->
        <!--          plain-->
        <!--          v-if="permission.repairtype_delete"-->
        <!--          @click="handleDelete"-->
        <!--          >删 除-->
        <!--        </el-button>-->
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="rowForbidden(scope.row.id)"
          v-if="scope.row.typeStatus == 0"
          >禁 用
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-finished"
          @click="rowStart(scope.row.id)"
          v-if="scope.row.typeStatus == 1"
          >启 用
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  forbidden,
  getDetail,
  getList,
  remove,
  update,
  start,
} from '@/api/v4ward/repairtype/repairtype';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        selection: true,
        indexLabel: '序号',
        viewBtn: true,
        delBtn: false,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '小区',
            prop: 'areaId',
            searchPlaceholder: '小区',
            placeholder: '不选默认为适配所有小区',
            search: true,
            props: {
              label: 'title',
              value: 'id',
            },
            dicUrl: '/api/repairtype/optionNode',
            type: 'select',
            dataType: 'string',
            clearable: true,
          },
          {
            label: '类型名称',
            prop: 'typeName',
            rules: [
              {
                required: true,
                message: '请输入类型名称',
                trigger: 'change',
              },
            ],
            maxlength: 15,
            showWordLimit: true,
            search: true,
          },
          // {
          //   label: '是否付费',
          //   prop: 'isPay',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入是否付费',
          //       trigger: 'change',
          //     },
          //   ],
          //   search: true,
          //   props: {
          //     label: 'title',
          //     value: 'id',
          //   },
          //   dicData: [
          //     {
          //       title: '是',
          //       id: 1,
          //     },
          //     {
          //       title: '否',
          //       id: 0,
          //     },
          //   ],
          //   type: 'select',
          //   dataType: 'string',
          //   clearable: true,
          // },
          // {
          //   label: '是否审核',
          //   prop: 'isCheck',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入是否审核',
          //       trigger: 'change',
          //     },
          //   ],
          //   search: true,
          //   props: {
          //     label: 'title',
          //     value: 'id',
          //   },
          //   dicData: [
          //     {
          //       title: '是',
          //       id: 1,
          //     },
          //     {
          //       title: '否',
          //       id: 0,
          //     },
          //   ],
          //   type: 'select',
          //   dataType: 'string',
          //   clearable: true,
          // },
          // {
          //   label: '是否回访',
          //   prop: 'isVisit',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入是否回访',
          //       trigger: 'change',
          //     },
          //   ],
          //   search: true,
          //   props: {
          //     label: 'title',
          //     value: 'id',
          //   },
          //   dicData: [
          //     {
          //       title: '是',
          //       id: 1,
          //     },
          //     {
          //       title: '否',
          //       id: 0,
          //     },
          //   ],
          //   type: 'select',
          //   dataType: 'string',
          //   clearable: true,
          // },
          {
            label: '类型状态',
            prop: 'typeStatus',
            rules: [
              {
                required: true,
                message: '请输入类型状态',
                trigger: 'change',
              },
            ],
            search: true,
            props: {
              label: 'title',
              value: 'id',
            },
            dicData: [
              {
                title: '禁用',
                id: 1,
              },
              {
                title: '启用',
                id: 0,
              },
            ],
            type: 'select',
            dataType: 'string',
            clearable: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.repairtype_add, false),
        viewBtn: this.vaildData(this.permission.repairtype_view, false),
        delBtn: this.vaildData(this.permission.repairtype_delete, false),
        editBtn: this.vaildData(this.permission.repairtype_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      if (!row.areaId) {
        row.areaId = 0;
      }
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    rowForbidden(id) {
      this.$confirm('确定将选择数据禁用?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return forbidden({ id: id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    rowStart(id) {
      this.$confirm('确定将选择数据启用?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return start({ id: id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
